import { clsx } from 'clsx';
import { FC } from 'react';
import {
  percentageLabel,
  percentageLabelVariants,
} from '@/components/tournament-post-card/percentage-label.css.ts';

export const PercentageLabel: FC<{ value: number }> = ({ value }) => {
  const labelVariant = value < 40 ? 'low' : value > 59 ? 'high' : 'medium';
  return (
    <div
      className={clsx(percentageLabel, percentageLabelVariants[labelVariant])}
    >
      {value}%
    </div>
  );
};
